import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import PropTypes from 'prop-types';
import QueryStirng from 'query-string';
import { chatList } from 'modules/actions/chat';
import Template from 'components/pages/Chat/templates';
import { fetchOptions } from 'modules/actions/quality';
const domain = window.location.pathname.substring(1);
// const href = new URL(window.location.href).search;

const Chat = ({ match, location }) => {
  const { search } = location;
  const paramObj = QueryStirng.parse(search);
  const navigate = useHistory();
  const query = decodeURIComponent(domain).split('/');
  const dispatch = useDispatch();
  const preventClose = (e) => {
    let target = '/chat'
    if(e.which === 116 || (e.ctrlKey && e.which === 82)){
      e.preventDefault();
      if(sessionStorage.getItem('mbrId')) target = target + '?id=' + btoa(sessionStorage.getItem('mbrId'));
      navigate.push(target);
      window.location.reload();
    }
  }

  // 파라미터에 id(회원ID)가 있으면 세션에 저장 & 없으면 삭제
  if(paramObj.id) sessionStorage.setItem('mbrId', atob(paramObj.id)); // 회원 mbr_id
  else sessionStorage.removeItem('mbrId');

  useEffect(() => {
    dispatch(fetchOptions());
    dispatch(
      chatList({
        inType: query[1] ? 'query' : 'intro',
        inStr: query[1] || '', 
      })
    );

    (() => {
      window.addEventListener("keydown", preventClose);
    })();

    return () => {
      window.removeEventListener("keydown", preventClose);
    }

  }, []);

  return <Template />;
};
Chat.propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
};

Chat.defaultProps = {
  match: {},
  location: {},
};
export default Chat;
